export default "__VITE_ASSET__zRvofnCg__"